import React, { useEffect, useState } from 'react';
import JSZip from 'jszip';
import MobileNavBar from '../../Home/Components/MobileNavBar';
import NavBar from '../../Home/Components/NavBar';

const galleryImages = [
  ['https://i.ibb.co.com/Wp7RBMQh/IMG-5187.jpg', 'https://i.ibb.co.com/HpR9Gb0S/IMG-5187.jpg'],
  ['https://i.ibb.co.com/HfzZgQkH/IMG-5186.jpg', 'https://i.ibb.co.com/Rk08HWVD/IMG-5186.jpg'],
  ['https://i.ibb.co.com/6RSXqtPc/IMG-5185.jpg', 'https://i.ibb.co.com/0jLsz9Mp/IMG-5185.jpg'],
  ['https://i.ibb.co.com/mCcPKQmr/IMG-5184.jpg', 'https://i.ibb.co.com/Gv5rDgXf/IMG-5184.jpg'],
  ['https://i.ibb.co.com/5Wm0z3jS/IMG-5183.jpg', 'https://i.ibb.co.com/fYfgKWNy/IMG-5183.jpg'],
  ['https://i.ibb.co.com/Wv2z79kr/IMG-5182.jpg', 'https://i.ibb.co.com/TMg0JX4Q/IMG-5182.jpg'],
  ['https://i.ibb.co.com/hJDRJw8c/IMG-5181.jpg', 'https://i.ibb.co.com/zTGhTDfF/IMG-5181.jpg'],
  ['https://i.ibb.co.com/1frqntKc/IMG-5180.jpg', 'https://i.ibb.co.com/C5b7t3vL/IMG-5180.jpg'],
  ['https://i.ibb.co.com/7xYy3rpZ/IMG-5179.jpg', 'https://i.ibb.co.com/qLy1Hmgc/IMG-5179.jpg'],
  ['https://i.ibb.co.com/9kGwBfLH/IMG-5178.jpg', 'https://i.ibb.co.com/Rk7htMmT/IMG-5178.jpg'],
  ['https://i.ibb.co.com/Rm2Gsq1/IMG-5177.jpg', 'https://i.ibb.co.com/2Qq0CTw/IMG-5177.jpg'],
  ['https://i.ibb.co.com/gZz2gNGP/IMG-5176.jpg', 'https://i.ibb.co.com/N2ZvY5Xm/IMG-5176.jpg'],
  ['https://i.ibb.co.com/DDFp7pZt/IMG-5175.jpg', 'https://i.ibb.co.com/7JD4G4qX/IMG-5175.jpg'],
  ['https://i.ibb.co.com/Y7vRM1j4/IMG-5174.jpg', 'https://i.ibb.co.com/KjC0kfyc/IMG-5174.jpg'],
  ['https://i.ibb.co.com/5g2FDh0Z/IMG-5173.jpg', 'https://i.ibb.co.com/rRvsP2j9/IMG-5173.jpg'],
  ['https://i.ibb.co.com/6JvK0WLP/IMG-5172.jpg', 'https://i.ibb.co.com/M58zkCQV/IMG-5172.jpg'],
  ['https://i.ibb.co.com/Fbt1ggXz/IMG-5171.jpg', 'https://i.ibb.co.com/N6zqZZrK/IMG-5171.jpg'],
  ['https://i.ibb.co.com/Kz9718vF/IMG-5170.jpg', 'https://i.ibb.co.com/BKgj1YMq/IMG-5170.jpg'],
  ['https://i.ibb.co.com/XrNQjY4S/IMG-5168.jpg', 'https://i.ibb.co.com/YFYCP0Wp/IMG-5168.jpg'],
  ['https://i.ibb.co.com/bgcgFHpv/IMG-5169.jpg', 'https://i.ibb.co.com/1fFfMsHX/IMG-5169.jpg'],
  ['https://i.ibb.co.com/hF2dy61C/IMG-5167.jpg', 'https://i.ibb.co.com/3mSF73Yk/IMG-5167.jpg'],
  ['https://i.ibb.co.com/HfySJ8fv/IMG-5166.jpg', 'https://i.ibb.co.com/RkKF5wkn/IMG-5166.jpg'],
  ['https://i.ibb.co.com/HLDNPHJ5/IMG-5165.jpg', 'https://i.ibb.co.com/rKGbpwWD/IMG-5165.jpg'],
  ['https://i.ibb.co.com/zW1dsvbn/IMG-5164.jpg', 'https://i.ibb.co.com/j9dthXG6/IMG-5164.jpg'],
  ['https://i.ibb.co.com/Df59FJg9/IMG-5163.jpg', 'https://i.ibb.co.com/PGwcyLzc/IMG-5163.jpg'],
  ['https://i.ibb.co.com/R4TJyhPM/IMG-5162.jpg', 'https://i.ibb.co.com/Kzx8wN7Q/IMG-5162.jpg'],
  ['https://i.ibb.co.com/jky2WBh6/IMG-5161.jpg', 'https://i.ibb.co.com/gZSpPHyj/IMG-5161.jpg'],
  ['https://i.ibb.co.com/FLjpYDkh/IMG-5160.jpg', 'https://i.ibb.co.com/ycb2kQmN/IMG-5160.jpg'],
  ['https://i.ibb.co.com/Sw7frgq4/IMG-5159.jpg', 'https://i.ibb.co.com/8g4YcwFL/IMG-5159.jpg'],
  ['https://i.ibb.co.com/fdb6Cy1N/IMG-5158.jpg', 'https://i.ibb.co.com/VYdnvzjC/IMG-5158.jpg'],
  ['https://i.ibb.co.com/pt1wmNZ/IMG-5157.jpg', 'https://i.ibb.co.com/mLRTxdt/IMG-5157.jpg'],
  ['https://i.ibb.co.com/zH5C0R3r/IMG-5156.jpg', 'https://i.ibb.co.com/JFd8M7YK/IMG-5156.jpg'],
  ['https://i.ibb.co.com/nNH5hZZM/IMG-5155.jpg', 'https://i.ibb.co.com/xtpRVPPq/IMG-5155.jpg'],
  ['https://i.ibb.co.com/20jsYL09/IMG-5154.jpg', 'https://i.ibb.co.com/cKNCXpKB/IMG-5154.jpg'],
  ['https://i.ibb.co.com/mr0DbN5T/IMG-5153.jpg', 'https://i.ibb.co.com/rK37Fd20/IMG-5153.jpg'],
  ['https://i.ibb.co.com/39tGn4Hr/IMG-5152.jpg', 'https://i.ibb.co.com/hJphSLv7/IMG-5152.jpg'],
  ['https://i.ibb.co.com/gMNzw0H9/IMG-5151.jpg', 'https://i.ibb.co.com/5WmBvQt4/IMG-5151.jpg'],
  ['https://i.ibb.co.com/d4FLL2N3/IMG-5150.jpg', 'https://i.ibb.co.com/tpgxxs0N/IMG-5150.jpg'],
  ['https://i.ibb.co.com/Mx5zrhGx/IMG-5149.jpg', 'https://i.ibb.co.com/DHgBhb8H/IMG-5149.jpg'],
  ['https://i.ibb.co.com/397Gt27F/IMG-5148.jpg', 'https://i.ibb.co.com/LX8b4m8g/IMG-5148.jpg'],
  ['https://i.ibb.co.com/3mhN2MX0/IMG-5147.jpg', 'https://i.ibb.co.com/MkNVrGTR/IMG-5147.jpg'],
  ['https://i.ibb.co.com/nqZSWjsG/IMG-5146.jpg', 'https://i.ibb.co.com/gbHCnJM2/IMG-5146.jpg'],
  ['https://i.ibb.co.com/23HN8Nnm/IMG-5145.jpg', 'https://i.ibb.co.com/TMdLKLvp/IMG-5145.jpg'],
  ['https://i.ibb.co.com/ymPPpjNF/IMG-5144.jpg', 'https://i.ibb.co.com/XfLLDRWx/IMG-5144.jpg'],
  ['https://i.ibb.co.com/cSwNtywd/IMG-5143.jpg', 'https://i.ibb.co.com/9khq2phj/IMG-5143.jpg'],
  ['https://i.ibb.co.com/JWJ1SpSF/IMG-5142.jpg', 'https://i.ibb.co.com/dsYTHpHJ/IMG-5142.jpg'],
  ['https://i.ibb.co.com/vCgYm4gs/IMG-5141.jpg', 'https://i.ibb.co.com/CpN2vKNJ/IMG-5141.jpg'],
  ['https://i.ibb.co.com/TBH7yK9q/IMG-5140.jpg', 'https://i.ibb.co.com/LzCcKQVh/IMG-5140.jpg'],
  ['https://i.ibb.co.com/sGHynrc/IMG-5139.jpg', 'https://i.ibb.co.com/bZJzTnY/IMG-5139.jpg'],
  ['https://i.ibb.co.com/0Rh7CWG9/IMG-5138.jpg', 'https://i.ibb.co.com/jPgNyxrw/IMG-5138.jpg'],
  ['https://i.ibb.co.com/p6GDkR4P/IMG-5137.jpg', 'https://i.ibb.co.com/wZ3H2wpL/IMG-5137.jpg'],
  ['https://i.ibb.co.com/9m5S5FgD/IMG-5136.jpg', 'https://i.ibb.co.com/7xmLmwCf/IMG-5136.jpg'],
  ['https://i.ibb.co.com/gLmwN02z/IMG-5135.jpg', 'https://i.ibb.co.com/4nKMzbqP/IMG-5135.jpg'],
  ['https://i.ibb.co.com/0yQxg3Z2/IMG-5134.jpg', 'https://i.ibb.co.com/VY3s78D9/IMG-5134.jpg'],
  ['https://i.ibb.co.com/23SD1dkX/IMG-5133.jpg', 'https://i.ibb.co.com/Swch4B3q/IMG-5133.jpg'],
  ['https://i.ibb.co.com/tM67pSMR/IMG-5132.jpg', 'https://i.ibb.co.com/fYWhdbYJ/IMG-5132.jpg'],
  ['https://i.ibb.co.com/rGDBjLQr/IMG-5131.jpg', 'https://i.ibb.co.com/8D1yCRmZ/IMG-5131.jpg'],
  ['https://i.ibb.co.com/fz93Zm7d/IMG-5130.jpg', 'https://i.ibb.co.com/xtYnwVQq/IMG-5130.jpg'],
  ['https://i.ibb.co.com/KxBbpCZ4/IMG-5129.jpg', 'https://i.ibb.co.com/b5YQMphw/IMG-5129.jpg'],
  ['https://i.ibb.co.com/ymDwN3Wr/IMG-5128.jpg', 'https://i.ibb.co.com/mrmLRx63/IMG-5128.jpg'],
  ['https://i.ibb.co.com/5WNnf0j6/IMG-5127.jpg', 'https://i.ibb.co.com/DDx8SJMt/IMG-5127.jpg'],
  ['https://i.ibb.co.com/nqVyPKvL/IMG-5126.jpg', 'https://i.ibb.co.com/spD4WXGV/IMG-5126.jpg'],
  ['https://i.ibb.co.com/zTpn5xgk/IMG-5125.jpg', 'https://i.ibb.co.com/392rsdbJ/IMG-5125.jpg'],
  ['https://i.ibb.co.com/XfDQTzjg/IMG-5124.jpg', 'https://i.ibb.co.com/5Xk0V5Gy/IMG-5124.jpg'],
  ['https://i.ibb.co.com/8ngxHFtZ/IMG-5123.jpg', 'https://i.ibb.co.com/203MTXH4/IMG-5123.jpg'],
  ['https://i.ibb.co.com/99GsNXSw/IMG-5122.jpg', 'https://i.ibb.co.com/GvFc0wNs/IMG-5122.jpg'],
  ['https://i.ibb.co.com/7c2gR7d/IMG-5121.jpg', 'https://i.ibb.co.com/KZFNLCp/IMG-5121.jpg'],
  ['https://i.ibb.co.com/Qv7zDhQd/IMG-5120.jpg', 'https://i.ibb.co.com/gZbH4Q9V/IMG-5120.jpg'],
  ['https://i.ibb.co.com/Y7MW0cfk/IMG-5119.jpg', 'https://i.ibb.co.com/wNXLcSpW/IMG-5119.jpg'],
  ['https://i.ibb.co.com/Q0bH6Vz/IMG-5118.jpg', 'https://i.ibb.co.com/XH25zPN/IMG-5118.jpg'],
  ['https://i.ibb.co.com/8yytRX9/IMG-5117.jpg', 'https://i.ibb.co.com/2zzHL5d/IMG-5117.jpg'],
  ['https://i.ibb.co.com/Nd1YcvTB/IMG-5116.jpg', 'https://i.ibb.co.com/gLvgk24K/IMG-5116.jpg'],
  ['https://i.ibb.co.com/nNwqd7Qh/IMG-5115.jpg', 'https://i.ibb.co.com/G4dfYWCg/IMG-5115.jpg'],
  ['https://i.ibb.co.com/NnZwK5bP/IMG-5114.jpg', 'https://i.ibb.co.com/mF6Q4kgw/IMG-5114.jpg'],
  ['https://i.ibb.co.com/zW0sYk15/IMG-5113.jpg', 'https://i.ibb.co.com/XfvXgw94/IMG-5113.jpg'],
  ['https://i.ibb.co.com/ynX6W66p/IMG-5112.jpg', 'https://i.ibb.co.com/BVtyqyyG/IMG-5112.jpg'],
  ['https://i.ibb.co.com/NgqQm5Hr/IMG-5111.jpg', 'https://i.ibb.co.com/20rmsxfS/IMG-5111.jpg'],
  ['https://i.ibb.co.com/TyCfKbY/IMG-5110.jpg', 'https://i.ibb.co.com/wtvkJwB/IMG-5110.jpg'],
  ['https://i.ibb.co.com/zWb2pQ0h/IMG-5108.jpg', 'https://i.ibb.co.com/9m246cC9/IMG-5108.jpg'],
  ['https://i.ibb.co.com/ZpHXgTTh/IMG-5107.jpg', 'https://i.ibb.co.com/fz8FN00C/IMG-5107.jpg'],
  ['https://i.ibb.co.com/rGdPpVCZ/IMG-5106.jpg', 'https://i.ibb.co.com/Z62sg0nh/IMG-5106.jpg'],
  ['https://i.ibb.co.com/0jZyYFp5/IMG-5105.jpg', 'https://i.ibb.co.com/Lz6d9JDK/IMG-5105.jpg'],
  ['https://i.ibb.co.com/q3Tby0S1/IMG-5104.jpg', 'https://i.ibb.co.com/Tx9zvKfh/IMG-5104.jpg'],
  ['https://i.ibb.co.com/BJMYyyb/IMG-5103.jpg', 'https://i.ibb.co.com/8wZQrrq/IMG-5103.jpg'],
  ['https://i.ibb.co.com/5gKh0kXh/IMG-5102.jpg', 'https://i.ibb.co.com/TxWMf1DM/IMG-5102.jpg'],
  ['https://i.ibb.co.com/cRFTWgj/IMG-5101.jpg', 'https://i.ibb.co.com/MKVNz2m/IMG-5101.jpg'],
  ['https://i.ibb.co.com/5XjYyyzt/IMG-5100.jpg', 'https://i.ibb.co.com/Y4dDMMKY/IMG-5100.jpg'],
  ['https://i.ibb.co.com/235MtRhs/IMG-5099.jpg', 'https://i.ibb.co.com/F4nYwc30/IMG-5099.jpg'],
  ['https://i.ibb.co.com/gb7XrGqx/IMG-5098.jpg', 'https://i.ibb.co.com/fVSKXb6s/IMG-5098.jpg'],
  ['https://i.ibb.co.com/MxKd8fgB/IMG-5097.jpg', 'https://i.ibb.co.com/YFJgDXN0/IMG-5097.jpg'],
  ['https://i.ibb.co.com/GQV2kSDd/IMG-5096.jpg', 'https://i.ibb.co.com/0yfMZbLn/IMG-5096.jpg'],
  ['https://i.ibb.co.com/Qvmd3QGk/IMG-5095.jpg', 'https://i.ibb.co.com/ZzTmpXCS/IMG-5095.jpg'],
  ['https://i.ibb.co.com/HTsgnnD0/IMG-5094.jpg', 'https://i.ibb.co.com/zVYfGGh1/IMG-5094.jpg'],
  ['https://i.ibb.co.com/6c5Y6yJB/IMG-5093.jpg', 'https://i.ibb.co.com/9mjnRp3t/IMG-5093.jpg'],
  ['https://i.ibb.co.com/nKJ4Jz1/IMG-5092.jpg', 'https://i.ibb.co.com/2p4R4gM/IMG-5092.jpg'],
  ['https://i.ibb.co.com/21nrFRh9/IMG-5091.jpg', 'https://i.ibb.co.com/S4sg6Hyj/IMG-5091.jpg'],
  ['https://i.ibb.co.com/s9dVWfFM/IMG-5090.jpg', 'https://i.ibb.co.com/b5MKb0r8/IMG-5090.jpg'],
  ['https://i.ibb.co.com/zHGcytdT/IMG-5089.jpg', 'https://i.ibb.co.com/93sXFdPk/IMG-5089.jpg'],
  ['https://i.ibb.co.com/fVMsJ9XM/IMG-5088.jpg', 'https://i.ibb.co.com/HL7jZCK7/IMG-5088.jpg'],
  ['https://i.ibb.co.com/SwqBv3nw/IMG-5086.jpg', 'https://i.ibb.co.com/N2wKYyj2/IMG-5086.jpg'],
  ['https://i.ibb.co.com/gFjJD9S5/IMG-5087.jpg', 'https://i.ibb.co.com/Wpxfc5kb/IMG-5087.jpg'],
];

const galleryItems = galleryImages.map(([thumb, full], index) => ({
  title: `SHD image share ${index + 1}`,
  thumb,
  full,
}));

const formatFileSize = (bytes) => {
  if (!bytes || Number.isNaN(Number(bytes))) return 'Unknown size';

  const units = ['B', 'KB', 'MB', 'GB'];
  let value = Number(bytes);
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  return `${value.toFixed(value >= 10 || unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
};

const ImageSharePage = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [imageSizes, setImageSizes] = useState({});
  const [zoomLevel, setZoomLevel] = useState(1);
  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [isDownloadingZip, setIsDownloadingZip] = useState(false);

  const getItemLabel = (index) => `SHD image share ${index + 1}`;

  useEffect(() => {
    const loadSizes = async () => {
      const nextSizes = {};

      await Promise.all(
        galleryItems.map(async (item) => {
          try {
            const response = await fetch(item.full, { method: 'HEAD', mode: 'cors' });
            const contentLength = response.headers.get('Content-Length');

            if (contentLength) {
              nextSizes[item.full] = formatFileSize(contentLength);
            }
          } catch (error) {
            nextSizes[item.full] = 'Unknown size';
          }
        })
      );

      setImageSizes(nextSizes);
    };

    loadSizes();
  }, []);

  const handleDownload = async (item, index) => {
    const fileName = `${getItemLabel(index).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}.jpg`;

    try {
      const response = await fetch(item.full, { mode: 'cors' });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      const fallbackLink = document.createElement('a');
      fallbackLink.href = item.full;
      fallbackLink.target = '_blank';
      fallbackLink.rel = 'noreferrer';
      fallbackLink.download = fileName;
      document.body.appendChild(fallbackLink);
      fallbackLink.click();
      fallbackLink.remove();
    }
  };

  const toggleSelection = (item) => {
    const itemId = item.full;
    setSelectedIds((current) => {
      if (current.includes(itemId)) {
        return current.filter((id) => id !== itemId);
      }

      return [...current, itemId];
    });
  };

  const handleBulkDownload = async () => {
    if (!selectedIds.length || isDownloadingZip) return;

    const items = galleryItems.filter((item) => selectedIds.includes(item.full));
    const zip = new JSZip();

    setIsDownloadingZip(true);
    setDownloadProgress(0);

    try {
      await Promise.all(
        items.map(async (item, index) => {
          const fileName = `${getItemLabel(galleryItems.findIndex((galleryItem) => galleryItem.full === item.full)).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}.jpg`;
          const response = await fetch(item.full, { mode: 'cors' });

          if (!response.ok) {
            throw new Error(`Failed to fetch ${item.title}`);
          }

          const blob = await response.blob();
          zip.file(fileName, blob);

          const nextProgress = Math.round(((index + 1) / items.length) * 100);
          setDownloadProgress(nextProgress);
        })
      );

      const zipBlob = await zip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'nkc-last-ride.zip';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setDownloadProgress(100);
      setSelectionMode(false);
      setSelectedIds([]);
    } catch (error) {
      console.error('Bulk download failed:', error);
      setDownloadProgress(0);
    } finally {
      setIsDownloadingZip(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#2b3944] px-4 pb-10 pt-4 text-white sm:px-6 lg:px-8">
      <div className="sticky top-3 z-[50] mb-8">
        <NavBar />
        <MobileNavBar />
      </div>

      <div className="mx-auto max-w-7xl">
        <header className="mb-8 flex flex-col gap-4 border-b border-white/10 pb-5 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-xs uppercase tracking-[0.24em] text-cyan-300">Gallery</p>
            <h1 className="mt-2 text-3xl font-bold sm:text-5xl">SHD image share</h1>
            <p className="mt-2 max-w-2xl text-sm text-rose-300 font-bold italic">
              This page is only visible to whom we have shared the link, and private otherwise. All images will be removed after 16th Oct, 2026. PLEASE DOWNLOAD YOUR COPY BEFORE...
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              onClick={() => {
                if (selectionMode) {
                  setSelectionMode(false);
                  setSelectedIds([]);
                } else {
                  setSelectionMode(true);
                }
              }}
              className="rounded-full border border-rose-400 bg-cyan-500/10 px-3 py-1.5 text-xs font-medium text-rose-200 transition hover:bg-rose-500/20 sm:text-sm"
            >
              {selectionMode ? 'Cancel selection' : 'Download multiple files by selecting'}
            </button>
            <div className="rounded-full border border-cyan-400/30 bg-cyan-500/10 px-3 py-1.5 text-sm font-medium text-cyan-200">
              {galleryItems.length} images
            </div>
          </div>
        </header>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4">
          {galleryItems.map((item, index) => {
            const itemLabel = getItemLabel(index);

            return (
            <article
              key={`${item.thumb}-${index}`}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#1f2a34] shadow-lg shadow-slate-950/25 transition-transform duration-200 hover:-translate-y-1"
            >
              <button
                type="button"
                onClick={() => {
                  if (selectionMode) {
                    toggleSelection(item);
                    return;
                  }

                  setSelectedItem(item);
                }}
                className="block w-full text-left"
                aria-label={selectionMode ? `Select ${itemLabel}` : `Open ${itemLabel}`}
              >
                <div className="relative h-48 overflow-hidden rounded-2xl bg-slate-800 sm:h-64 lg:h-72">
                  <img
                    src={item.thumb}
                    alt={itemLabel}
                    className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
                    loading="lazy"
                    onError={(event) => {
                      event.currentTarget.style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/10 to-transparent opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
                  <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-3 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                    <span className="rounded-full bg-slate-900/80 px-2.5 py-1 text-xs font-medium text-white">View</span>
                    <span className="rounded-full bg-cyan-500 px-2.5 py-1 text-xs font-medium text-slate-950">Open</span>
                  </div>
                </div>
              </button>
              <div className="pointer-events-none absolute left-3 top-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-[#1b2731]/80 px-2.5 py-1 text-[10px] font-medium text-slate-100 backdrop-blur-sm sm:text-xs">
                <span className="inline-block h-2.5 w-2.5 rounded-full bg-cyan-300 shadow-[0_0_10px_rgba(103,232,249,0.7)]" />
                {itemLabel}
              </div>

              {selectionMode && (
                <div className="absolute right-2 top-2 z-20 flex h-6 w-6 items-center justify-center rounded-full border border-white/10 bg-slate-900/70 text-xs font-semibold text-white shadow-lg">
                  {selectedIds.includes(item.full) ? '✓' : ''}
                </div>
              )}

              <div className="absolute bottom-3 right-3 rounded-full border border-white/10 bg-[#1b2731]/80 px-2.5 py-1 text-[10px] font-medium text-cyan-200 backdrop-blur-sm sm:text-[11px]">
                {imageSizes[item.full] || 'Loading…'}
              </div>
            </article>
            );
          })}
        </div>
      </div>

      {selectedItem && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/85 p-2 backdrop-blur-sm sm:p-4"
          onClick={() => {
            setSelectedItem(null);
            setZoomLevel(1);
          }}
        >
          <div
            className="relative w-full max-w-[96vw] rounded-[28px] border border-white/10 bg-slate-900 p-2 shadow-2xl sm:max-w-6xl sm:p-4"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="mb-3 flex flex-col gap-3 px-1 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex flex-wrap items-center gap-2 text-xs text-slate-300 sm:text-sm">
                <span className="font-medium text-white">Full size preview</span>
                <span className="rounded-full border border-cyan-400/30 bg-cyan-500/10 px-2 py-0.5 text-[10px] text-cyan-200 sm:text-xs">
                  {imageSizes[selectedItem.full] || 'Loading…'}
                </span>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  onClick={() => setZoomLevel((prev) => Math.min(prev + 0.5, 2.5))}
                  className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs text-white transition hover:bg-white/10 sm:text-sm"
                >
                  Zoom +
                </button>
                <button
                  type="button"
                  onClick={() => setZoomLevel((prev) => Math.max(prev - 0.5, 1))}
                  className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs text-white transition hover:bg-white/10 sm:text-sm"
                >
                  Zoom -
                </button>
                <button
                  type="button"
                  onClick={() => handleDownload(selectedItem, galleryItems.findIndex((item) => item.full === selectedItem.full))}
                  className="rounded-full bg-rose-500 px-3 py-1.5 text-xs font-medium text-slate-950 transition hover:bg-rose-400 sm:text-sm"
                >
                  Download
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setSelectedItem(null);
                    setZoomLevel(1);
                  }}
                  className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs text-white transition hover:bg-white/10 sm:text-sm"
                >
                  Close
                </button>
              </div>
            </div>

            <div className="flex max-h-[76vh] items-center justify-center overflow-hidden rounded-2xl bg-slate-950 p-1 sm:p-2">
              <img
                src={selectedItem.full}
                alt={getItemLabel(galleryItems.findIndex((item) => item.full === selectedItem.full))}
                className="max-h-[74vh] w-full rounded-xl object-contain shadow-[0_0_30px_rgba(15,23,42,0.7)] transition-transform duration-200 ease-out"
                style={{
                  transform: `scale(${zoomLevel})`,
                  transformOrigin: 'center center',
                  cursor: zoomLevel > 1 ? 'zoom-out' : 'zoom-in',
                }}
                onClick={() => setZoomLevel((prev) => (prev > 1 ? 1 : 1.75))}
              />
            </div>
          </div>
        </div>
      )}

      {selectionMode && selectedIds.length > 0 && (
        <button
          type="button"
          onClick={handleBulkDownload}
          className="fixed bottom-4 right-4 z-[60] rounded-full bg-rose-500 px-4 py-3 text-sm font-bold text-slate-950 shadow-[0_12px_30px_rgba(34,211,238,0.45)] transition hover:bg-rose-400"
        >
          {isDownloadingZip ? `Downloading ${downloadProgress}%` : `Download (${selectedIds.length})`}
        </button>
      )}
    </div>
  );
};

export default ImageSharePage;
